import React, { useEffect, useState, useRef } from "react";
import { Navbar, Nav, Dropdown, Badge, OverlayTrigger, Tooltip } from "react-bootstrap";
import { FaBell, FaSignOutAlt } from "react-icons/fa";

const notificationSoundUrl = "https://actions.google.com/sounds/v1/alarms/alarm_clock.ogg";

const DoctorNavbar = ({ doctor }) => {
  const [notificationCount, setNotificationCount] = useState(0);
  const [isBouncing, setIsBouncing] = useState(false);
  const soundRef = useRef(null);

  // Function to fetch new appointment count from backend
  // const fetchNewAppointmentCount = async () => {
  //   try {
  //     const res = await fetch(`https://ricgop.online/api/get_new_appointments.php?doctor_id=${doctor?.id}`);
  //     const data = await res.json();
  //     return data.count || 0;
  //   } catch (err) {
  //     console.error("Error fetching appointment count:", err);
  //     return 0;
  //   }
  // };

  // Polling effect for notifications
  // useEffect(() => {
  //   const pollNotifications = async () => {
  //     try {
  //       const newCount = await fetchNewAppointmentCount();
  //       if (newCount > notificationCount) {
  //         setIsBouncing(true);
  //         if (soundRef.current) soundRef.current.play();
  //       }
  //       setNotificationCount(newCount);
  //     } catch (err) {
  //       console.error("Failed to fetch notifications", err);
  //     }
  //   };

  //   pollNotifications();
  //   const interval = setInterval(pollNotifications, 15000);
  //   return () => clearInterval(interval);
  // }, [notificationCount]);

  useEffect(() => {
    if (isBouncing) {
      const timer = setTimeout(() => setIsBouncing(false), 1500);
      return () => clearTimeout(timer);
    }
  }, [isBouncing]);

  const handleLogout = () => {
    localStorage.clear();
    window.location.href = "/doctor/login";
  };

  const getInitials = (name = "") =>
    name
      .split(" ")
      .map((n) => n[0])
      .join("")
      .toUpperCase();

  return (
    <>
      <Navbar expand="lg" sticky="top" className="modern-navbar px-4 py-2">
        <Navbar.Brand className="brand">Doctor Portal</Navbar.Brand>

        <Nav className="ms-auto align-items-center" style={{ gap: 36 }}>
          {/* <OverlayTrigger
            placement="bottom"
            overlay={<Tooltip id="notif-tooltip">New Patient Appointments</Tooltip>}
          >
            <div
              className={`notif-bell ${isBouncing ? "bounce" : ""}`}
              aria-label={`You have ${notificationCount} new appointment${notificationCount !== 1 ? "s" : ""}`}
              title={`You have ${notificationCount} new appointment${notificationCount !== 1 ? "s" : ""}`}
              role="button"
              tabIndex={0}
            >
              <FaBell size={24} />
              {notificationCount > 0 && (
                <Badge pill bg="danger" className="notif-badge">
                  {notificationCount}
                </Badge>
              )}
            </div>
          </OverlayTrigger> */}

          <Dropdown align="end">
            <Dropdown.Toggle className="doctor-dropdown" id="doctor-dropdown-toggle">
              <div className="avatar-circle" title={doctor?.name || "Doctor"}>
                {getInitials(doctor?.name)}
              </div>
              <span className="doctor-name">Dr. {doctor?.name || "Doctor"}</span>
            </Dropdown.Toggle>

            <Dropdown.Menu>
              <Dropdown.Item href="/doctor/profile">Profile</Dropdown.Item>
              <Dropdown.Divider />
              <Dropdown.Item onClick={handleLogout} className="text-danger d-flex align-items-center gap-2">
                <FaSignOutAlt /> Logout
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </Nav>

        <audio ref={soundRef} src={notificationSoundUrl} preload="auto" />
      </Navbar>

      <style>{`
        .modern-navbar {
          background: linear-gradient(160deg, #e6fff2, #e1f3ff);
          box-shadow: 0 8px 30px rgba(0, 0, 0, 0.08);
          border-bottom: none;
          font-family: 'Segoe UI', Tahoma, sans-serif;
          border-radius: 0 0 20px 20px;
        }

        .brand {
          font-weight: 700;
          font-size: 24px;
          color: #256d85;
        }

        .notif-bell {
          position: relative;
          color: #2c3e50;
          cursor: pointer;
          transition: transform 0.3s ease;
        }

        .notif-badge {
          position: absolute;
          top: -5px;
          right: -10px;
          font-size: 12px;
        }

        .notif-bell.bounce {
          animation: bell-bounce 0.7s ease-in-out;
        }

        @keyframes bell-bounce {
          0%, 100% { transform: rotate(0); }
          20% { transform: rotate(-20deg); }
          40% { transform: rotate(20deg); }
          60% { transform: rotate(-10deg); }
          80% { transform: rotate(10deg); }
        }

        .avatar-circle {
          background: #ffffff;
          color: #256d85;
          width: 40px;
          height: 40px;
          border-radius: 50%;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          font-weight: bold;
          box-shadow: 0 6px 20px rgba(0, 0, 0, 0.1);
        }

        .doctor-name {
          font-weight: 600;
          color: #256d85;
        }

        .doctor-dropdown {
          background: transparent;
          border: none;
          box-shadow: none;
          display: flex;
          align-items: center;
          gap: 10px;
        }

        .dropdown-menu {
          border-radius: 12px;
          box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
        }

        .dropdown-item:hover {
          background: #f0faff;
          color: #00796b;
        }
      `}</style>
    </>
  );
};

export default DoctorNavbar;
